import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import CloseIcon from "@mui/icons-material/Close";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_GROUP_FEE } from "../../Schema/GroupFee";
import { translateLauguage } from "../../Function/Translate";

export default function DeleteGroupFee({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [deleteGroupFee] = useMutation(DELETE_GROUP_FEE, {
    onCompleted: ({ deleteGroupFee }) => {
      setLoading(false);
      if (deleteGroupFee?.status === true) {
        setAlert(true, "success", deleteGroupFee?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteGroupFee?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteGroupFee({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Delete group fee
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              {/* {t("thead_delete_des")} */}
              Do you want to delete this data?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                {t("delete")}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
